var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"bg-input",attrs:{"type":"number"},domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input', parseInt($event.target.value || '0'))}}})}
var staticRenderFns = []

export { render, staticRenderFns }